import {setIsBusy} from './GlobalThunks';

export const GlobalActions = {
  setIsBusy,
};
